import React from 'react';
import { Paper, Text, ActionIcon, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import DataTables from 'components/DataTables';
import type { CoursePlanJobFamilyGroupForm } from '../../../../types/lcms/coursePlan';

/* eslint-disable */
interface JobFamilyGroupTableProps {
  dataJobFamilyGroups: CoursePlanJobFamilyGroupForm[];
  onRemove: (jobFamilyGroupId: string) => void;
  mode?: 'add' | 'edit' | 'view';
}
/* eslint-enable */

const JobFamilyGroupTable: React.FC<JobFamilyGroupTableProps> = ({
  dataJobFamilyGroups,
  onRemove,
  mode = 'add'
}) => {
  const columns = [
    {
      heading: 'Job Group Family Name',
      active: true,
      props: (row: CoursePlanJobFamilyGroupForm) => (
        <Text size='sm' fw={500}>
          {row.jobFamilyGroupName}
        </Text>
      )
    },
    {
      heading: 'Actions',
      active: true,
      props: (row: CoursePlanJobFamilyGroupForm) => (
        <Tooltip label='Remove Job Family Group'>
          <ActionIcon
            variant='subtle'
            color='red'
            onClick={() => onRemove(row.jobFamilyGroupId)}
            disabled={mode === 'view'}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Tooltip>
      )
    }
  ];

  if (dataJobFamilyGroups.length === 0) {
    return (
      <Text c='dimmed' size='sm' style={{ fontStyle: 'italic' }}>
        {mode === 'view'
          ? 'No job family groups assigned to this plan'
          : 'Click "Add Job Family Groups" to select job family groups (requires Business Unit selection first)'}
      </Text>
    );
  }

  return (
    <Paper withBorder p={16} radius='lg'>
      <Text fw={500} size='sm' mb={12}>
        Selected Job Family Groups ({dataJobFamilyGroups.length})
      </Text>
      <DataTables
        data={dataJobFamilyGroups}
        columns={columns}
        withPagination={false}
        isNumbering={false}
        loading={false}
      />
    </Paper>
  );
};

export default JobFamilyGroupTable;
